import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const INITIAL_STATE = fromJS({
  loggingIn: false,
  loggingInResponseMessage: '',
  loggingOut: false,
  token: '',
  username: '',
  email: '',
  roles: fromJS([]),
  id: '',
  departmentId: ''
});

function login(state) {
  return state.set('loggingIn', true);
}

function loginSuccess(state, action) {
  try {
    return state.set('loggingIn', false)
      .set('username', action.payload.body.username)
      .set('email', action.payload.body.email)
      .set('roles', fromJS(action.payload.body.roles))
      .set('token', action.payload.body.token)
      .set('departmentId', action.payload.body.departmentId)
      .set('id', action.payload.body.userId)
  }
  catch (e) {
    return state.set('loggingIn', false);
  }
}

function loginFail(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message;
  } catch (e) {
    msg = 'Failed to log in'
  }
  return state.set('loggingIn', false)
    .set('loggingInResponseMessage', msg)
}

function changeUserStoreSettings(state, action) {
  return state.set(action.payload.key, action.payload.value)
}

function logout(state, action) {
  return INITIAL_STATE
    .set('loggingOut', true);
}

function logoutSuccess(state, action) {
  return INITIAL_STATE
    .set('loggingOut', false);
}

function logoutFail(state, action) {
  return INITIAL_STATE
    .set('loggingOut', false);
}

function resetState(state, action) {
  return INITIAL_STATE
}

export const loggedInPerson = createReducer(INITIAL_STATE, {
  [ActionTypes.LOGIN]: login,
  [ActionTypes.LOGIN_SUCCESS]: loginSuccess,
  [ActionTypes.LOGIN_FAIL]: loginFail,
  [ActionTypes.CHANGE_USER_STORE_SETTINGS]: changeUserStoreSettings,
  [ActionTypes.LOG_OUT]: logout,
  [ActionTypes.lOG_OUT_SUCCESS]: logoutSuccess,
  [ActionTypes.LOG_OUT_FAIL]: logoutFail,
  [ActionTypes.RESET_STATE]: resetState
});



// WEBPACK FOOTER //
// ./src/reducers/loggedInPerson.js